import { useQuery } from '@tanstack/react-query';
import { conversationClient } from '@/lib/gupshup-client';
import { useBrandFilter } from '@/components/brand-filter/brand-filter-context';

interface UseHandoffCountOptions {
    enabled: boolean;
    interval?: number;
}

export function useHandoffCount({ enabled, interval = 15000 }: UseHandoffCountOptions) {
    const { brandIdsParam, brandFilterKey } = useBrandFilter();
    // On error React Query keeps the last data, so transient failures don't
    // reset the badge (same behavior as the old polling hook).
    const { data } = useQuery({
        queryKey: ['handoff-count', brandFilterKey],
        queryFn: async () => {
            const response = await conversationClient.conversations.getHandoffCount({ brandIds: brandIdsParam });
            return response.count;
        },
        enabled,
        refetchInterval: interval,
    });

    return { handoffCount: data ?? 0 };
}
